export const LABELS = {
  EXPORT: ['components.filters.export.label', 'Export'],
  MODAL_TITLE: ['components.filters.export.modalTitle', 'Export Order List'],
  FILTERS_TITLE: ['components.filters.export.filtersTitle', 'Filters'],
  EMPTY_FILTERS: ['components.filters.export.emptyFilters', 'No filters applied.'],
  DISCLAIMER: ['components.filters.export.disclaimer', 'The export creates a CSV file.'],
  CLOSE_BUTTON_TITLE: ['components.filters.export.cancel', 'Cancel'],
  EXPORT_BUTTON_TITLE: ['components.filters.export.export', 'Export'],
};
